export enum DataHooks {
  WRAPPER = 'list-filter-wrapper',
  DropDown = 'list-filter-dropdown',
  Tabs = 'list-filter-tabs',
  Tags = 'list-filter-tags',
}
